(function(){

    const currencySelect = document.getElementById("currencies");
    const supported_currencies = "AED|ALL|AMD|ANG|AOA|ARS|AUD|AWG|AZN|BAM|BBD|BDT|BGN|BHD|BND|BOB|BRL|BSD|BTN|BWP|BYR|BZD|CAD|CHF|CLP|CNY|COP|CRC|CZK|DKK|DOP|DZD|EGP|ETB|EUR|FJD|GBP|GEL|GHS|GMD|GTQ|GYD|HKD|HNL|HRK|HUF|IDR|ILS|INR|ISK|JEP|JMD|JOD|JPY|KES|KGS|KHR|KRW|KWD|KYD|KZT|LBP|LKR|LTL|LVL|MAD|MDL|MGA|MKD|MMK|MNT|MOP|MUR|MVR|MXN|MYR|MZN|NAD|NGN|NIO|NOK|NPR|NZD|OMR|PEN|PGK|PHP|PKR|PLN|PYG|QAR|RON|RSD|RUB|RWF|SAR|SCR|SEK|SGD|STD|SYP|THB|TND|TRY|TTD|TWD|TZS|UAH|UGX|USD|UYU|VEF|VND|VUV|WST|XAF|XBT|XCD|XOF|XPF|ZAR|ZMW";
    const savedCurrency = localStorage.getItem("preferredCurrency") || "MXN";
    
    // Encuentra el script JSON
    const script = document.querySelector("script[type='application/json'][data-section-type='header']");

    if (script) {
        try {
            // Parsea el contenido como JSON
            const data_without_Dn = script.textContent.replace(/\n/g, "");
            const data_without_space = data_without_Dn.replace(/ /g, "");
            const data = JSON.parse(data_without_space);

            // Accede al array de monedas
            const store_currencies = data.currency.currency_converter_currencies;

            if(!currencySelect){
                console.log("Elemento con ID 'currencies' no encontrado.");
                return;
            }

            currencySelect.innerHTML = "";

            store_currencies.forEach(function(code){
                if(!supported_currencies.includes(code)) return; 

                const option = document.createElement("option");
                option.value = code;
                option.textContent = code;

                if(code === savedCurrency){
                    option.selected = true;
                }

                currencySelect.appendChild(option);
            });

        } catch (e) {
            console.log('Error parsing JSON from script tag:', e);
        }
    }
})();